import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=d51150e0&scoped=true&"
import script from "./MainTitle.vue?vue&type=script&lang=js&"
export * from "./MainTitle.vue?vue&type=script&lang=js&"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=d51150e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51150e0",
  null
  
)

export default component.exports